var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseDataList',{ref:"dataList",attrs:{"items":_vm.contactRequests,"service":_vm.fetchContactRequests},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('ContactRequestListHeader')]},proxy:true},{key:"default",fn:function({ item }){return [_c('ContactRequestListItem',{attrs:{"contact-request":item}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }